import { isCheckCategoryVersion } from "helpers/category";
import {
  EntityInput,
  isURLAbsolute,
  LinkProps,
  withTrailSlash,
} from "helpers/url";

export function categoryHref(
  entity: EntityInput,
  region?: string
): LinkProps["href"] {
  let obj: LinkProps["href"] = {
    pathname: "/category/[category]",
    query: {
      category: entity.alias,
    },
  };

  if (entity.url) {
    if (isURLAbsolute(entity.url)) {
      return entity.url;
    }

    if (isCheckCategoryVersion(entity.url, 1)) {
      obj.query = { category: entity.url.replace(/\//g, "").replace("c_", "") };
    } else if (entity.url.startsWith("/catalog/")) {
      obj.pathname = "/catalog/[...category]";
      obj.query = { category: entity.url.replace("/catalog/", "") };
    } else {
      obj = {
        pathname: entity.url,
      };
    }
  }

  if (region) {
    obj.query = {
      ...((obj.query as object) || {}),
      region,
    };
  }

  return obj;
}

export function categoryAs(
  entity: EntityInput,
  region?: string
): LinkProps["as"] {
  const regionSegment = region ? `r_${region}/` : "";
  if (entity.url) {
    if (isURLAbsolute(entity.url)) {
      return entity.url;
    }

    return `${withTrailSlash(entity.url)}${
      entity.utm ? regionSegment + entity.utm : regionSegment
    }`;
  }

  return `/c_${entity.alias.replace("/", "")}/${
    entity.utm ? regionSegment + entity.utm : regionSegment
  }`;
}

/**
 * @deprecated
 * @param category
 */
export function categoryRecovery(category: string): string {
  if (!category || typeof category !== "string") return "";

  return category.replace(/;/g, "/");
}
